/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import PurchaserForm from './PurchaserForm';
import 'styles/components/purchase/PaymentOptions';
import PaymentOptionsType from './PaymentOptionsType';

/**
 * PaymentOptions component.
 * Renders payment options and purchaser form based on configuration.
 * The purchaser form can be hidden for exchange tickets using the HIDE_EXCHANGE_PURCHASER_FORM feature flag.
 * @param {object} props - Component props
 * @param {function} props.submitPurchaser - Function to handle purchaser form submission
 * @param {boolean} props.isExchange - Flag indicating if this is an exchange transaction
 * @param {boolean} props.removeTopMargin - Flag to remove top margin from container
 * @param {boolean} props.hidePurchaserForm - Flag to hide purchaser form (overrides feature flag)
 */
const PaymentOptions = (props) => {
  const { features } = useSelector((state) => state.whitelabelConfig);
  const {
    submitPurchaser,
    onSubmitPurchaserFail,
    isExchange,
    removeTopMargin,
    hidePurchaserForm = false,
    collapsiblePurchaserForm = false,
    purchaserFormDefaultExpanded = false,
  } = props;

  const SHOW_PURCHASER_FORM = features.PURCHASER_FORM_ON === 'CHECKOUT';
  const showInvoiceToggle = features.ENABLE_INVOICE_IN_CHECKOUT;

  // Hide PurchaserForm if it's an exchange and the feature flag is enabled or if hidePurchaserForm is enabled
  const shouldHidePurchaserForm =
    hidePurchaserForm || (isExchange && features.HIDE_EXCHANGE_PURCHASER_FORM);

  return (
    <div className={removeTopMargin ? 'payment-content remove-top-margin' : ''}>
      {SHOW_PURCHASER_FORM && (
        <div className={shouldHidePurchaserForm ? 'hidden-purchaser-form' : ''}>
          <PurchaserForm
            onSubmit={submitPurchaser}
            onSubmitPurchaserFail={onSubmitPurchaserFail}
            showPurchaserForm={SHOW_PURCHASER_FORM}
            isExchange={isExchange}
            showInvoiceToggle={showInvoiceToggle}
            collapsible={collapsiblePurchaserForm}
            defaultExpanded={purchaserFormDefaultExpanded}
          />
        </div>
      )}

      <PaymentOptionsType {...props} />
    </div>
  );
};

PaymentOptions.propTypes = {
  availablePayments: PropTypes.array.isRequired,
  onPaymentTypeChange: PropTypes.func.isRequired,
  submitPurchaser: PropTypes.func.isRequired,
  onSubmitPurchaserFail: PropTypes.func,
  isOpenTicket: PropTypes.bool.isRequired,
  selectedOption: PropTypes.string.isRequired,
  cardErrorOccured: PropTypes.bool,
  initialPurchaserValues: PropTypes.object,
  isExchange: PropTypes.bool,
  removeTopMargin: PropTypes.bool,
  hidePurchaserForm: PropTypes.bool,
  collapsiblePurchaserForm: PropTypes.bool,
  purchaserFormDefaultExpanded: PropTypes.bool,
};

export default PaymentOptions;
